/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Browser_LinkInputs */

const en_gc_resources_download_browser_link = /** @type {(inputs: Gc_Resources_Download_Browser_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the workspace`)
};

const zh_gc_resources_download_browser_link = /** @type {(inputs: Gc_Resources_Download_Browser_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开工作空间`)
};

/**
* | output |
* | --- |
* | "Open the workspace" |
*
* @param {Gc_Resources_Download_Browser_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_browser_link = /** @type {((inputs?: Gc_Resources_Download_Browser_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Browser_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_browser_link(inputs)
	return zh_gc_resources_download_browser_link(inputs)
});
export { gc_resources_download_browser_link as "gc.resources.download.browser_link" }